import { CloseFilled } from '@icon';
import React from 'react';
import { components, OptionTypeBase } from 'react-select';
import { useTheme } from 'styled-components';

const MultiValueRemove = <OptionType extends OptionTypeBase, IsMulti extends boolean>(
  props: any,
) => {
  const theme = useTheme();
  return (
    <components.MultiValueRemove {...props}>
      <CloseFilled width={20} height={20} color={theme.color.tint.tertiary} />
    </components.MultiValueRemove>
  );
};

export default MultiValueRemove;
